<h3 class="greeting accent">{{'MSG.GREETING' | translate}}</h3>
<small class="login-title accent set-font-size">{{'LABEL.RSYAP' | translate}}</small>

<form class="flex-col lt" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
	<label class="text-light label-control" for="email">{{'LABEL.EMAIL' | translate}}</label>
	<mat-form-field color="accent" appearance="outline">
		<input formControlName="email" id="email" type="email" matInput required
			[placeholder]="'LABEL.EMAIL' | translate | titlecase">
		<mat-icon matPrefix svgIcon="email"></mat-icon>
	</mat-form-field>
	<mat-error @fadeOpInOut *ngIf="emailControl.invalid && emailControl.touched">{{ 'MSG.VALID_EMAIL_REQUIRED' | translate }}</mat-error>
	
	<button color="accent" mat-flat-button type="submit" class="submit">
		{{'LABEL.RESET_PASSWORD' | translate}}
	</button>
</form>

<div class="alert">
	<!-- <p class="lt">{{'MSG.DONT_HAVE_ACC' | translate}} 
		<a class="accent" routerLink="/auth/register">
			{{'LABEL.REGISTER_HERE' | translate}}
		</a>
	</p> -->
	<p class="lt">{{'MSG.HAVE_ACC' | translate}} 
		<a class="accent" routerLink="/auth/login">
			{{'LABEL.LOGIN' | translate}}
		</a>
	</p>
</div>